/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "@/shared/api/axiosInstance";
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  DeleteApiV1SerieSerieidLangsIdMutationResponse,
  DeleteApiV1SerieSerieidLangsIdPathParams,
  DeleteApiV1SerieSerieidLangsId401,
  DeleteApiV1SerieSerieidLangsId404,
  DeleteApiV1SerieSerieidLangsId500,
} from "../../types/serieIdiomasController/DeleteApiV1SerieSerieidLangsId.ts";

function getDeleteApiV1SerieSerieidLangsIdUrl(
  serieId: DeleteApiV1SerieSerieidLangsIdPathParams["serieId"],
  id: DeleteApiV1SerieSerieidLangsIdPathParams["id"],
) {
  const res = {
    method: "DELETE",
    url: `/api/v1/serie/${serieId}/langs/${id}` as const,
  };
  return res;
}

/**
 * @description Remove uma tradução (idioma) da série. **(Requer Authorization para autenticação)**
 * @summary Excluir idioma da série (Requer Authorization para autenticação)
 * {@link /api/v1/serie/:serieId/langs/:id}
 */
export async function deleteApiV1SerieSerieidLangsId(
  serieId: DeleteApiV1SerieSerieidLangsIdPathParams["serieId"],
  id: DeleteApiV1SerieSerieidLangsIdPathParams["id"],
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    DeleteApiV1SerieSerieidLangsIdMutationResponse,
    ResponseErrorConfig<
      | DeleteApiV1SerieSerieidLangsId401
      | DeleteApiV1SerieSerieidLangsId404
      | DeleteApiV1SerieSerieidLangsId500
    >,
    unknown
  >({
    method: "DELETE",
    url: getDeleteApiV1SerieSerieidLangsIdUrl(serieId, id).url.toString(),
    ...requestConfig,
  });
  return res.data;
}
